import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e9f081e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "country-cloud" }

import { computed } from 'vue'
import { ValueCount } from '@/rd/ResearchDataModel'
import { useExploreStore } from '@/explore/ExploreStore'
import { useViewScopeStore } from '../ViewScopeStore'
import { usePlaceAnalysis } from './PlaceAnalysis'
import { getTopValues } from '@/util/AnalysisUtil'
import { LoadMode } from '@/util/AsyncData'


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryCloud',
  props: {
    countries: {}
  },
  setup(__props: any) {

const props = __props;

const positionSequence = [0, 3, 5, 7, 1, 2, 4, 6, 8]



const { getScopeCountryCodes } = usePlaceAnalysis()
const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()

const scopeInfoRef = computed(() =>
  props.countries ? undefined : viewScopeStore.getAsyncScopeInfo(exploreStore.startPersonId, LoadMode.EnsureLoaded)?.data,
)

const topCountriesRef = computed(() => {
  if (props.countries) {
    return props.countries.slice(0, 9)
  }
  if (scopeInfoRef.value) {
    const countryCodes = [...getScopeCountryCodes(scopeInfoRef.value)]
    return getTopValues(countryCodes, 10)
  }
  return []
})

const maxCount = computed(() => Math.max(...topCountriesRef.value.map(c => c.count), 1))

function flagClasses(c: ValueCount, index: number) {
  const size = Math.round((c.count / maxCount.value) * 3) // sizes: 0-3
  const posIndex = positionSequence[index]
  return ['flag', 'fi', `fi-${c.value.toLowerCase()}`, `pos-${posIndex}`, `size-${size}`]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topCountriesRef.value, (c, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: c.value,
        class: _normalizeClass(flagClasses(c, i))
      }, null, 2))
    }), 128))
  ]))
}
}

})